module.exports = __webpack_public_path__ + "img/pr-7.25f8ffb6.png";